module.exports = __webpack_public_path__ + "img/qr.9eeedf25.svg";